<template>
  <div role="radio" tabindex="0"
       :aria-checked="value === inputValue"
       class="cursor-pointer focus:outline-none"
       :class="{ 'cursor-not-allowed': disabled }"
       @click="toggle"
       @keydown.space.prevent="toggle"
       @focus="hasFocus = true"
       @blur="hasFocus = false"
  >
    <slot />

    <label class="flex cursor-pointer items-center" :class="[labelClass, { 'cursor-not-allowed': disabled }]">
      <div v-if="value === inputValue" class="h-16 w-16 rounded-full flex flex-shrink-0 justify-center items-center border border-grey-700">
        <div class="w-12 h-12 rounded-full bg-main-color" />
      </div>
      <div v-else class="h-16 w-16 rounded-full border border-grey-700 flex-shrink-0" />
      <slot name="label" />
      <span class="ml-8">{{ label }}</span>
    </label>
  </div>
</template>

<script>
import { defineComponent, ref } from 'vue'

export default defineComponent({
  props: {
    value: { type: String },
    inputValue: { type: String },
    label: { type: String },
    labelClass: { type: [String, Array] },
    hasBorder: { type: Boolean, default: false },
    disabled: { type: Boolean, default: false }
  },

  emits: ['input'],

  setup (props, { emit }) {
    const hasFocus = ref(false)

    function toggle () {
      emit('input', props.inputValue)
    }

    return { hasFocus, toggle }
  }
})
</script>
